import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Knowledge from "../pages/knowledge/page";
import About from "../pages/about/page";
import Booking from "../pages/booking/page";
import BookingSuccess from "../pages/booking-success/page";
import Contact from "../pages/contact/page";
import ProductDetail from "../pages/product-detail/page";
import CartPage from "../pages/cart/page";
import Checkout from "../pages/checkout/page";
import OrderConfirmation from "../pages/order-confirmation/page";
import OrderLookup from "../pages/order-lookup/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import VerifyEmail from "../pages/verify-email/page";
import ForgotPassword from "../pages/forgot-password/page";
import ResetPassword from "../pages/reset-password/page";
import ResendVerification from "../pages/resend-verification/page";
import Terms from "../pages/terms/page";
import NewsletterUnsubscribe from "../pages/newsletter-unsubscribe/page";
import AccountProfile from "../pages/account/page";
import AccountOrders from "../pages/account/orders/page";
import AccountOrderDetail from "../pages/account/orders/detail";
import AccountReservations from "../pages/account/reservations/page";
import AccountSupport from "../pages/account/support/page";
import ArticleDetail from "../pages/article-detail/page";
import HearingTest from "../pages/hearing-test/page";
import Association from "../pages/association/page";
import HearingChronicDisease from "../pages/hearing-chronic-disease/page";
import Faq from "../pages/faq/page";
import AdminLogin from "../pages/admin/AdminLogin";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminReservations from "../pages/admin/AdminReservations";
import AdminUsers from "../pages/admin/AdminUsers";
import AdminStoreUsers from "../pages/admin/AdminStoreUsers";
import AdminStoreOverview from "../pages/admin/AdminStoreOverview";
import AdminStoreCalendars from "../pages/admin/AdminStoreCalendars";
import AdminStoreCustomers from "../pages/admin/AdminStoreCustomers";
import AdminStoreSalesOrders from "../pages/admin/AdminStoreSalesOrders";
import AdminStoreOrderStatuses from "../pages/admin/AdminStoreOrderStatuses";
import AdminStoreServiceRecords from "../pages/admin/AdminStoreServiceRecords";
import AdminStoreFollowUps from "../pages/admin/AdminStoreFollowUps";
import AdminStoreActivityLogs from "../pages/admin/AdminStoreActivityLogs";
import AdminStoreAnnouncements from "../pages/admin/AdminStoreAnnouncements";
import AdminStoreReports from "../pages/admin/AdminStoreReports";
import AdminStorePaymentReconciliation from "../pages/admin/AdminStorePaymentReconciliation";
import AdminErp from "../pages/admin/AdminErp";
import AdminProducts from "../pages/admin/AdminProducts";
import AdminProductForm from "../pages/admin/AdminProductForm";
import AdminOrders from "../pages/admin/AdminOrders";
import AdminOrderDetail from "../pages/admin/AdminOrderDetail";
import AdminMembers from "../pages/admin/AdminMembers";
import AdminMemberDetail from "../pages/admin/AdminMemberDetail";
import AdminProductCategories from "../pages/admin/AdminProductCategories";
import AdminProductTrialReservations from "../pages/admin/AdminProductTrialReservations";
import AdminContactMessages from "../pages/admin/AdminContactMessages";
import AdminCustomerServiceCenter from "../pages/admin/AdminCustomerServiceCenter";
import AdminKnowledgeArticles from "../pages/admin/AdminKnowledgeArticles";
import AdminKnowledgeArticleForm from "../pages/admin/AdminKnowledgeArticleForm";
import AdminKnowledgeArticleCategories from "../pages/admin/AdminKnowledgeArticleCategories";
import AdminFaqCategories from "../pages/admin/AdminFaqCategories";
import AdminFaqItems from "../pages/admin/AdminFaqItems";
import AdminNewsCategories from "../pages/admin/AdminNewsCategories";
import AdminNewsItems from "../pages/admin/AdminNewsItems";
import AdminNewsItemForm from "../pages/admin/AdminNewsItemForm";
import AdminTeamMembers from "../pages/admin/AdminTeamMembers";
import AdminTestimonials from "../pages/admin/AdminTestimonials";
import AdminShippingMethods from "../pages/admin/AdminShippingMethods";
import AdminLogisticsSettings from "../pages/admin/AdminLogisticsSettings";
import AdminShippingRules from "../pages/admin/AdminShippingRules";
import AdminShippingCoupons from "../pages/admin/AdminShippingCoupons";
import AdminPaymentMethods from "../pages/admin/AdminPaymentMethods";
import AdminOperationLocations from "../pages/admin/AdminOperationLocations";
import AdminNewsletterSubscribers from "../pages/admin/AdminNewsletterSubscribers";
import AdminNewsletterCampaigns from "../pages/admin/AdminNewsletterCampaigns";
import AdminNewsletterCampaignForm from "../pages/admin/AdminNewsletterCampaignForm";
import AdminStaticPages from "../pages/admin/AdminStaticPages";
import AdminStaticPageForm from "../pages/admin/AdminStaticPageForm";
import AdminHomeSections from "../pages/admin/AdminHomeSections";
import AdminCompanyProfile from "../pages/admin/AdminCompanyProfile";
import AdminBookingAvailability from "../pages/admin/AdminBookingAvailability";
import AdminMenuItems from "../pages/admin/AdminMenuItems";
import AdminRefunds from "../pages/admin/AdminRefunds";
import AdminFinanceReport from "../pages/admin/AdminFinanceReport";
import AdminPaymentTransactions from "../pages/admin/AdminPaymentTransactions";
import AdminInvoiceSettings from "../pages/admin/AdminInvoiceSettings";
import StoreLogin from "../pages/store/StoreLogin";
import StoreDashboard from "../pages/store/StoreDashboard";
import StoreReservations from "../pages/store/StoreReservations";
import StoreCustomers from "../pages/store/StoreCustomers";
import StoreServiceRecords from "../pages/store/StoreServiceRecords";
import StoreOrders from "../pages/store/StoreOrders";
import StoreFollowUps from "../pages/store/StoreFollowUps";
import StoreAnnouncements from "../pages/store/StoreAnnouncements";
import StoreSchedule from "../pages/store/StoreSchedule";
import StoreGoogleCalendar from "../pages/store/StoreGoogleCalendar";
import StoreReports from "../pages/store/StoreReports";
import ErpLogin from "../pages/erp/ErpLogin";
import ErpDashboard from "../pages/erp/ErpDashboard";
import ErpOperations from "../pages/erp/ErpOperations";
import News from "../pages/news/page";
import NewsDetail from "../pages/news-detail/page";
import StaticPageView from "../pages/static-page/page";

import AsiaSummit from "../pages/asia-summit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/product/:id",
    element: <ProductDetail />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/order-confirmation/:orderNumber",
    element: <OrderConfirmation />,
  },
  {
    path: "/order-lookup",
    element: <OrderLookup />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/resend-verification",
    element: <ResendVerification />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/newsletter/unsubscribe",
    element: <NewsletterUnsubscribe />,
  },
  {
    path: "/account",
    element: <AccountProfile />,
  },
  {
    path: "/account/orders",
    element: <AccountOrders />,
  },
  {
    path: "/account/orders/:orderNumber",
    element: <AccountOrderDetail />,
  },
  {
    path: "/account/reservations",
    element: <AccountReservations />,
  },
  {
    path: "/account/support",
    element: <AccountSupport />,
  },
  {
    path: "/knowledge",
    element: <Knowledge />,
  },
  {
    path: "/hearing-chronic-disease",
    element: <HearingChronicDisease />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/:id",
    element: <NewsDetail />,
  },
  {
    path: "/article/:id",
    element: <ArticleDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/association",
    element: <Association />,
  },
  {
    path: "/asia-summit",
    element: <AsiaSummit />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "/booking-success",
    element: <BookingSuccess />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/hearing-test",
    element: <HearingTest />,
  },
  {
    path: "/admin-login",
    element: <AdminLogin />,
  },
  {
    path: "/store-login",
    element: <StoreLogin />,
  },
  {
    path: "/erp-login",
    element: <ErpLogin />,
  },
  {
    path: "/erp/dashboard",
    element: <ErpDashboard />,
  },
  {
    path: "/erp/inventory",
    element: <ErpOperations view="inventory" />,
  },
  {
    path: "/erp/inventory/:productId",
    element: <ErpOperations view="inventory-detail" />,
  },
  {
    path: "/erp/stock-units",
    element: <ErpOperations view="units" />,
  },
  {
    path: "/erp/stock-movements",
    element: <ErpOperations view="movements" />,
  },
  {
    path: "/erp/inventory-counts",
    element: <ErpOperations view="inventory-counts" />,
  },
  {
    path: "/erp/inventory-counts/:stockAdjustmentId",
    element: <ErpOperations view="inventory-count-detail" />,
  },
  {
    path: "/erp/inventory-counts/new",
    element: <ErpOperations view="inventory-count-create" />,
  },
  {
    path: "/erp/stock-adjustments",
    element: <ErpOperations view="adjustments" />,
  },
  {
    path: "/erp/stock-adjustments/:stockAdjustmentId",
    element: <ErpOperations view="adjustment-detail" />,
  },
  {
    path: "/erp/stock-adjustments/new",
    element: <ErpOperations view="adjustment-create" />,
  },
  {
    path: "/erp/stock-transfers",
    element: <ErpOperations view="transfers" />,
  },
  {
    path: "/erp/stock-transfers/new",
    element: <ErpOperations view="transfer-create" />,
  },
  {
    path: "/erp/purchase-orders",
    element: <ErpOperations view="purchase" />,
  },
  {
    path: "/erp/purchase-suggestions",
    element: <ErpOperations view="purchase-suggestions" />,
  },
  {
    path: "/erp/purchase-orders/new",
    element: <ErpOperations view="purchase-create" />,
  },
  {
    path: "/erp/purchase-receipts",
    element: <ErpOperations view="purchase-receipts" />,
  },
  {
    path: "/erp/purchase-receipts/:purchaseReceiptId",
    element: <ErpOperations view="purchase-receipt-detail" />,
  },
  {
    path: "/erp/payables",
    element: <ErpOperations view="payables" />,
  },
  {
    path: "/erp/rma-orders",
    element: <ErpOperations view="rma-orders" />,
  },
  {
    path: "/erp/outbound-orders",
    element: <ErpOperations view="outbound" />,
  },
  {
    path: "/erp/outbound-orders/new",
    element: <ErpOperations view="outbound-create" />,
  },
  {
    path: "/erp/quality-inspections",
    element: <ErpOperations view="quality-inspections" />,
  },
  {
    path: "/erp/reports",
    element: <ErpOperations view="reports" />,
  },
  {
    path: "/erp/audit-logs",
    element: <ErpOperations view="audit-logs" />,
  },
  {
    path: "/erp/attachments",
    element: <ErpOperations view="attachments" />,
  },
  {
    path: "/erp/tasks",
    element: <ErpOperations view="tasks" />,
  },
  {
    path: "/erp/import-batches",
    element: <ErpOperations view="import-batches" />,
  },
  {
    path: "/erp/accounting-periods",
    element: <ErpOperations view="accounting-periods" />,
  },
  {
    path: "/erp/warehouses",
    element: <ErpOperations view="warehouses" />,
  },
  {
    path: "/erp/suppliers",
    element: <ErpOperations view="suppliers" />,
  },
  {
    path: "/erp/suppliers/new",
    element: <ErpOperations view="supplier-create" />,
  },
  {
    path: "/erp/suppliers/:supplierId/edit",
    element: <ErpOperations view="supplier-edit" />,
  },
  {
    path: "/store/dashboard",
    element: <StoreDashboard />,
  },
  {
    path: "/store/reservations",
    element: <StoreReservations />,
  },
  {
    path: "/store/reservations/:sourceType/:id",
    element: <StoreReservations />,
  },
  {
    path: "/store/customers",
    element: <StoreCustomers />,
  },
  {
    path: "/store/customers/:customerKey",
    element: <StoreCustomers />,
  },
  {
    path: "/store/service-records",
    element: <StoreServiceRecords />,
  },
  {
    path: "/store/service-records/new",
    element: <StoreServiceRecords />,
  },
  {
    path: "/store/service-records/:serviceRecordId",
    element: <StoreServiceRecords />,
  },
  {
    path: "/store/orders",
    element: <StoreOrders />,
  },
  {
    path: "/store/orders/:storeSalesOrderId",
    element: <StoreOrders />,
  },
  {
    path: "/store/follow-ups",
    element: <StoreFollowUps />,
  },
  {
    path: "/store/announcements",
    element: <StoreAnnouncements />,
  },
  {
    path: "/store/announcements/:storeAnnouncementId",
    element: <StoreAnnouncements />,
  },
  {
    path: "/store/reports",
    element: <StoreReports />,
  },
  {
    path: "/store/schedule",
    element: <StoreSchedule />,
  },
  {
    path: "/store/google-calendar",
    element: <StoreGoogleCalendar />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/reservations",
    element: <AdminReservations title="父親節活動預約列表" />,
  },
  {
    path: "/admin/product-trial-reservations",
    element: <AdminProductTrialReservations />,
  },
  {
    path: "/admin/contact-messages",
    element: <AdminContactMessages />,
  },
  {
    path: "/admin/customer-service",
    element: <AdminCustomerServiceCenter />,
  },
  {
    path: "/admin/products",
    element: <AdminProducts />,
  },
  {
    path: "/admin/products/new",
    element: <AdminProductForm />,
  },
  {
    path: "/admin/products/:id/edit",
    element: <AdminProductForm />,
  },
  {
    path: "/admin/orders",
    element: <AdminOrders />,
  },
  {
    path: "/admin/orders/:id",
    element: <AdminOrderDetail />,
  },
  {
    path: "/admin/members",
    element: <AdminMembers />,
  },
  {
    path: "/admin/members/:id",
    element: <AdminMemberDetail />,
  },
  {
    path: "/admin/knowledge-articles",
    element: <AdminKnowledgeArticles />,
  },
  {
    path: "/admin/knowledge-articles/new",
    element: <AdminKnowledgeArticleForm />,
  },
  {
    path: "/admin/knowledge-articles/:id/edit",
    element: <AdminKnowledgeArticleForm />,
  },
  {
    path: "/admin/knowledge-article-categories",
    element: <AdminKnowledgeArticleCategories />,
  },
  {
    path: "/admin/faq-items",
    element: <AdminFaqItems />,
  },
  {
    path: "/admin/team-members",
    element: <AdminTeamMembers />,
  },
  {
    path: "/admin/testimonials",
    element: <AdminTestimonials />,
  },
  {
    path: "/admin/shipping-methods",
    element: <AdminShippingMethods />,
  },
  {
    path: "/admin/logistics-setting",
    element: <AdminLogisticsSettings />,
  },
  {
    path: "/admin/shipping-rules",
    element: <AdminShippingRules />,
  },
  {
    path: "/admin/shipping-coupons",
    element: <AdminShippingCoupons />,
  },
  {
    path: "/admin/payment-methods",
    element: <AdminPaymentMethods />,
  },
  {
    path: "/admin/operation-locations",
    element: <AdminOperationLocations />,
  },
  {
    path: "/admin/newsletter-subscribers",
    element: <AdminNewsletterSubscribers />,
  },
  {
    path: "/admin/newsletter-campaigns",
    element: <AdminNewsletterCampaigns />,
  },
  {
    path: "/admin/newsletter-campaigns/new",
    element: <AdminNewsletterCampaignForm />,
  },
  {
    path: "/admin/newsletter-campaigns/:id/edit",
    element: <AdminNewsletterCampaignForm />,
  },
  {
    path: "/admin/static-pages",
    element: <AdminStaticPages />,
  },
  {
    path: "/admin/static-pages/new",
    element: <AdminStaticPageForm />,
  },
  {
    path: "/admin/static-pages/:id/edit",
    element: <AdminStaticPageForm />,
  },
  {
    path: "/admin/home-sections",
    element: <AdminHomeSections />,
  },
  {
    path: "/admin/company-profile",
    element: <AdminCompanyProfile />,
  },
  {
    path: "/admin/booking-availability",
    element: <AdminBookingAvailability />,
  },
  {
    path: "/page/:slug",
    element: <StaticPageView />,
  },
  {
    path: "/admin/faq-categories",
    element: <AdminFaqCategories />,
  },
  {
    path: "/admin/news-items",
    element: <AdminNewsItems />,
  },
  {
    path: "/admin/news-items/new",
    element: <AdminNewsItemForm />,
  },
  {
    path: "/admin/news-items/:id/edit",
    element: <AdminNewsItemForm />,
  },
  {
    path: "/admin/news-categories",
    element: <AdminNewsCategories />,
  },
  {
    path: "/admin/product-categories",
    element: <AdminProductCategories />,
  },
  {
    path: "/admin/users",
    element: <AdminUsers />,
  },
  {
    path: "/admin/store-overview",
    element: <AdminStoreOverview />,
  },
  {
    path: "/admin/store-calendars",
    element: <AdminStoreCalendars />,
  },
  {
    path: "/admin/store-users",
    element: <AdminStoreUsers />,
  },
  {
    path: "/admin/store-customers",
    element: <AdminStoreCustomers />,
  },
  {
    path: "/admin/store-sales-orders",
    element: <AdminStoreSalesOrders />,
  },
  {
    path: "/admin/store-order-statuses",
    element: <AdminStoreOrderStatuses />,
  },
  {
    path: "/admin/store-service-records",
    element: <AdminStoreServiceRecords />,
  },
  {
    path: "/admin/store-follow-ups",
    element: <AdminStoreFollowUps />,
  },
  {
    path: "/admin/store-reports",
    element: <AdminStoreReports />,
  },
  {
    path: "/admin/store-payment-reconciliation",
    element: <AdminStorePaymentReconciliation />,
  },
  {
    path: "/admin/store-activity-logs",
    element: <AdminStoreActivityLogs />,
  },
  {
    path: "/admin/store-announcements",
    element: <AdminStoreAnnouncements />,
  },
  {
    path: "/admin/erp",
    element: <AdminErp view="dashboard" />,
  },
  {
    path: "/admin/erp-inventory",
    element: <AdminErp view="inventory" />,
  },
  {
    path: "/admin/erp-purchase-orders",
    element: <AdminErp view="purchase" />,
  },
  {
    path: "/admin/erp-outbound-orders",
    element: <AdminErp view="outbound" />,
  },
  {
    path: "/admin/menu-items",
    element: <AdminMenuItems />,
  },
  {
    path: "/admin/refunds",
    element: <AdminRefunds />,
  },
  {
    path: "/admin/finance-reports",
    element: <AdminFinanceReport />,
  },
  {
    path: "/admin/payment-transactions",
    element: <AdminPaymentTransactions />,
  },
  {
    path: "/admin/invoice-setting",
    element: <AdminInvoiceSettings />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
